module.exports = __webpack_public_path__ + "img/05.513ee507.png";